var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowDown = function SvgArrowDown(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    fill: "none",
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#arrow_down_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F96155",
    d: "M5.947 11.964a2.114 2.114 0 0 1-.188-.105.905.905 0 0 1-.156-.124L2.11 8.226a.87.87 0 0 1-.238-.344 1.083 1.083 0 0 1 0-.787.87.87 0 0 1 .238-.344 1.018 1.018 0 0 1 .746-.312c.289 0 .532.105.729.312L5.29 8.457v-6.56a1 1 0 0 1 .312-.745A1.022 1.022 0 0 1 6.34.85c.295 0 .545.1.746.303.202.203.304.451.304.746v6.559L9.095 6.75a1.018 1.018 0 0 1 .746-.312c.29 0 .538.105.746.312.207.208.312.456.312.746a.965.965 0 0 1-.312.73l-3.492 3.508a3.213 3.213 0 0 1-.165.124c-.057.04-.117.075-.18.105h-.016a1.155 1.155 0 0 1-.59.05.874.874 0 0 1-.18-.048l-.017-.002Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrow_down_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h11.992v11.992H0z",
    transform: "translate(.6 .593)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDown);
export default ForwardRef;